import type { IconName } from '@sparklayer-io/spark-dash-ui/components/ui/icon/types';
import { Heading, Icon, Pressable, Spinner, Text } from '@ui/themed';

export type IconCardProps = {
  icon: IconName;
  title: string;
  subtitle: string;
  /** When provided, the whole card becomes a button */
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
};

// A tinted card with a coloured icon tile, a title and a subtitle
function IconCardBody({ icon, title, subtitle, loading }: Omit<IconCardProps, 'onClick'>) {
  return (
    <div className="flex w-full items-center gap-3 rounded-xl bg-platform-primary/5 p-4 text-start">
      <span className="flex size-11 shrink-0 items-center justify-center rounded-lg border border-spark-border-contrast bg-platform-primary/10 text-platform-primary">
        {loading ? <Spinner /> : <Icon name={icon} size="md" />}
      </span>
      <div className="flex min-w-0 flex-col gap-0.5">
        <Heading level="span" style="sm">
          {title}
        </Heading>
        <Text size="sm" variant="secondary">
          {subtitle}
        </Text>
      </div>
    </div>
  );
}

export function IconCard({ onClick, disabled, ...props }: IconCardProps) {
  if (!onClick) {
    return <IconCardBody {...props} />;
  }

  return (
    <Pressable type="card" fullWidth fullHeight onClick={onClick} disabled={disabled}>
      <IconCardBody {...props} />
    </Pressable>
  );
}
